import { AccordionSummary as Mui4AccordionSummary } from '@material-ui/core'
import {
  AccordionSummaryProps as Mui5AccordionSummaryProps,
  default as Mui5AccordionSummary,
} from '@mui/material/AccordionSummary'
import { forwardRef } from 'react'
import { useComponentVersion } from '../../hooks/useComponentVersion'
import { OsAccordionVersion } from './Accordion'

export type AccordionSummaryProps = Mui5AccordionSummaryProps

export const AccordionSummary = forwardRef<HTMLDivElement, AccordionSummaryProps>((props, ref) => {
  const version = useComponentVersion('accordion')

  switch (version) {
    case OsAccordionVersion.V2:
      return <Mui5AccordionSummary {...props} ref={ref} />
    default:
      return <Mui4AccordionSummary {...props} ref={ref} />
  }
})
